import { render, staticRenderFns } from "./searchbar.vue?vue&type=template&id=5b7517ee&scoped=true&"
import script from "./searchbar.vue?vue&type=script&lang=js&"
export * from "./searchbar.vue?vue&type=script&lang=js&"
import style0 from "./searchbar.vue?vue&type=style&index=0&id=5b7517ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7517ee",
  null
  
)

export default component.exports